import { render, staticRenderFns } from "./BatchRefuseTeam.vue?vue&type=template&id=a54a78ea"
import script from "./BatchRefuseTeam.vue?vue&type=script&lang=ts"
export * from "./BatchRefuseTeam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports